module.exports = __webpack_public_path__ + "static/media/boy-sitting.f29b6a98.PNG";